"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * interface无法声明非基本类型的约束，例如Set、Map,所以暂不做约束
 */
var UIP_Config = {
    // set存入对应use注入的Function
    _middlewares: new Set(),
    // 是否允许特意覆盖的标识
    _isoverride: false,
    // 针对某方法前置拦截的相关配置，形式{string:Array},其中key为对应方法名，value为对应拦截回调的Function数组
    _intercepts: new Map()
};
var UIP = {
    // 全局默认配置，如设置全局suuid、token等
    defaultConfig: {},
    use: function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var length = args.length;
        if (length < 1)
            return this;
        else if (length === 1) {
            this.inject(args[0]);
        }
        else {
            args.map(function (item) { return _this.inject(item); });
        }
        /** 返回this，支持链式调用 */
        return this;
    },
    /**
     * 检查是否已经注入
     * 重复注入的场景一般是针对同一引用的function/arg {name:string,install:Function}进行注入，Set检测即可
     * 针对name不同,且Function引用也不同的，无法通过Set或者其他对比检测重复注入问题
     *  */
    inject: function (arg) {
        /**
         * 假的UIP形参并用this替换,
         * 支持外部第一层一个UIP参数，也支持特定形式的高阶函数嵌套处理(即挂载高阶函数返回值function的这种情形)
         * 高阶函数格式需要将UIP对象放置在最后一个参数来处理(更新1.0.8)
         * eg:(...config)=>UIP=>UIP.xx=config
         */
        var args = [this];
        if (typeof arg === 'function') {
            /** 需要支持手动重写(非恶意覆盖 即_isoverride为true */
            if (UIP_Config._middlewares.has(arg) && !UIP_Config._isoverride)
                return this;
            UIP_Config._middlewares.add(arg);
            /** 为支持高阶函数第一层不传参数调用
             * 采用对最外层解耦执行来判断是否是高级函数，并对高阶函数默认多执行一层调用 */
            var cb = arg.apply(this, args);
            if (typeof cb === 'function') {
                /** 高阶函数的情况下，需要更改最外层默认传参(缺省值)并重新执行 */
                var cn = arg.call(this);
                cn.apply(this, args);
            }
        }
        else {
            // UIPOBJECT
            UIP_Config._middlewares.add(arg.install);
            if (typeof arg.install === 'function')
                arg.install.apply(arg, args);
        }
    },
    /**
     * 针对某一方法的前置回调拦截，callback返回true则继续执行该方法，不返回/false则不执行
     * intercept默认返回对该拦截的副作用消除方法
     * name默认为对应Function name
     * callback如有返回值且不为false，才会依次管道执行，并最终执行对应name的方法
     * 否则默认做劫持操作，即不继续执行对应name方法
     *  */
    intercept: function (name, callback) {
        var value = UIP_Config._intercepts.get(name) || [];
        value.push(callback);
        UIP_Config._intercepts.set(name, value);
        /** 返回副作用 */
        return function () {
            /** 删除value数组(引用类型，一直跟随最新)的对应项，可能不是最后一项，所以用indexOf先查找下标 */
            var index = value.indexOf(callback);
            if (index < 0)
                return;
            value.splice(index, 1);
            UIP_Config._intercepts.set(name, value);
        };
    },
    /**
     * 拦截企图被覆盖的同名实体方法，避免无恶意的覆盖导致原本的方法错误调用
     * 如确实需要覆盖，则调用override来重写方法
     * Proxy为原生API，调用需考虑相关平台兼容性
     *
     * @change  修改此方法作为通用的proxy拦截处理方法，不单独只支持UIP对象形参使用
     *  */
    proxy: function (self) {
        return new Proxy(self, {
            set: function (target, key, value, receiver) {
                if (!UIP_Config._isoverride && receiver && receiver[key]) {
                    // 原对象存在且并没有设置确定覆盖的标识
                    console.warn("Function " + key + " is exist,please check again or take 'override' function ");
                    return receiver[key];
                }
                return Reflect.set(target, key, value, receiver);
            },
            get: function (target, key, receiver) {
                /** 需要前置判断是否有对该方法的intercept，如果有则每步确认return来确定执行next */
                var arr = UIP_Config._intercepts.get(key);
                if (!arr || !arr.length) {
                    return Reflect.get(target, key, receiver);
                }
                /**
                 * 管道式拦截 暂时只支持同步拦截器（主要原因在于Proxy get/set不支持async）
                 * 如拦截器数组中有某项false，则直接返回空Function
                 * */
                var res = arr.reduce(function next(prev, cur) {
                    /** 判断prev返回true则继续执行 */
                    if (prev)
                        return cur.call(self, arguments);
                    else
                        return false;
                }, true);
                if (!res) {
                    console.info("Function " + key + " is intercept");
                    return new Function();
                }
                return Reflect.get(target, key, receiver);
            }
        });
    },
    /**
     * 覆盖之前同名方法(特意覆盖)
     *  */
    override: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        /** 设置覆盖标识符 */
        UIP_Config._isoverride = true;
        this.use.apply(this, args);
        UIP_Config._isoverride = false;
        return this;
    },
    /**
     * 用于多个preset的合并
     * preset的输出格式为UIP对象
     * 默认会覆盖this
     */
    extend: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        /** 设置覆盖标识符,避免覆盖时set拦截 */
        UIP_Config._isoverride = true;
        var _UIP = Object.assign.apply(Object, __spreadArrays([this], args));
        UIP_Config._isoverride = false;
        return _UIP;
    },
    /**
     * 用于检测是否已存在了相关对象
     * UIP.checkModule('utils', 'check', 'env')
     * 不存在的层级创建空对象
     */
    checkModule: function () {
        var modules = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            modules[_i] = arguments[_i];
        }
        modules.reduce(function (prev, cur) {
            if (!prev[cur])
                prev[cur] = {};
            return prev[cur];
        }, UIP);
    },
    /**
     * 设置全局通用配置，提供给外部应用
     */
    setDefaultConfig: function (config) {
        Object.assign(this.defaultConfig, config);
    }
};
/**
 * 针对Proxy的兼容性问题处理，保证在Proxy不兼容的环境也能正常使用UIP use等
 * Proxy为原生API
 * 目前测试支持情况如下：
 * RN 0.59版本以上均支持
 * 微信小程序库版本 1.6.8以上均支持
 * web IE9及以上均支持
 *  */
try {
    /** 如果支持Proxy，则返回UIP的代理对象 */
    UIP = UIP.proxy(UIP);
}
catch (e) {
    console.warn(e);
}
exports.default = UIP;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/core/dist/index.js
// module id = MVhJ
// module chunks = 1